export default "__VITE_ASSET__ec32a6de__"